import * as React from "react";
import { useAccess } from "./duck/hooks";
import { NoAccess } from "../errors";

interface AccessRouteProps {
  children: React.ReactNode;
  path: string;
}

const AccessRoute: React.FC<AccessRouteProps> = ({ children, path }) => {
  const failedLicense = useAccess(path);

  if (failedLicense) {
    return <NoAccess failedLicense={failedLicense} />;
  }

  return <>{children}</>;
};

export default AccessRoute;
